import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {ref, onValue} from 'firebase/database'
import StartFirebase from '../firebaseConfig/config';
//import useMousePosition from './mousePosition';
import { useState, useEffect } from "react";
import 
{ 
    FinishedGamesContainer,
    FinishedGamesH1,
    FinishedGamesH2,
    FinishedGamesCard,
    FinishedGamesIcon,
    FinishedGamesP,
    FinishedGamesWrapper,
    FinishedGamesContentWrapper,
    FinishedGamesA,
    FinishedGamesContent,
    FinishedGamesRating,
    FGWrapper,
    FGCard,
    FGContainer,
    FGIcon,
    FGCardContent,
    FGH1,
    FGH2,
    FGTags,
    FGHeader,
    FGA

} from './FinishedGamesElements'

const db = StartFirebase()

export class UpcomingGames extends React.Component{
    constructor(){
        super()
        this.state = {
            finishedGameData: [],
            upcomingGameData: [],
        }
    }
    componentDidMount(){
        const dbRefFinished = ref(db, '/finished_games')
        const dbRefUpcoming = ref(db, '/upcoming_games')

        onValue(dbRefFinished, (snapshot) => {
            let records = [];
            snapshot.forEach(childSnapshot => {
                let keyName = childSnapshot.key;
                let data = childSnapshot.val();
                records.push({"key": keyName, "data": data});
            });
            this.setState({finishedGameData: records});
        });

        onValue(dbRefUpcoming, (snapshot) => {
            let records = [];
            snapshot.forEach(childSnapshot => {
                let keyName = childSnapshot.key;
                let data = childSnapshot.val();
                records.push({"key": keyName, "data": data});
            });
            this.setState({upcomingGameData: records});
        });
    }

    

    render()
    {
        return (
            
            <FGContainer id="upcoming_games">
                <FGHeader>Nadcházející hry</FGHeader>
                <FGWrapper>
                    {
                        this.state.upcomingGameData.sort(function (a, b) {
                            if (a.data.title < b.data.title) {
                              return -1;
                            }
                            if (a.data.title > b.data.title) {
                              return 1;
                            }
                            return 0;}
                            ).slice(0).map((game, index) => {
                            
                            return(
                                <FGCard className="card">
                                    <FGIcon src={game.data.artwork_link} />
                                    <FGCardContent>
                                        <FGH1>{game.data.title}</FGH1>
                                        <FGTags>
                                            <FGH2>Claimed by: {game.data.claimed_by}</FGH2>
                                        </FGTags>
                                    </FGCardContent>
                                </FGCard>
                            )
                        })
                    }
                </FGWrapper>
            </FGContainer>
            // <FinishedGamesContainer id="games">
            //     <FinishedGamesH1>Dohrané hry</FinishedGamesH1>
            //     <FinishedGamesWrapper>
            //         {
            //             this.state.finishedGameData.slice(0).reverse().map((s) => 
            //             {
            //                 return (
            //                     <FinishedGamesCard>
            //                         <FinishedGamesIcon src={s.data.artwork_link}/>
            //                         <FinishedGamesContentWrapper>
            //                             <FinishedGamesContent>
            //                                 <FinishedGamesH2>{s.data.title}</FinishedGamesH2>
            //                                 <FinishedGamesP>Dohráno: {s.data.finished_date}</FinishedGamesP>
            //                                 <FinishedGamesA href={s.data.link_to_store}>Odkaz na hru</FinishedGamesA>
            //                             </FinishedGamesContent>

            //                             <FinishedGamesRating>
            //                                 <CircularProgressbar 
            //                                 minValue={0} 
            //                                 maxValue={10} 
            //                                 value={s.data.rating} 
            //                                 text={s.data.rating}
            //                                 styles={buildStyles({
            //                                     pathColor: `#ff1a1a`,
            //                                     textColor: '#ff1a1a',
            //                                     trailColor: '#fff',
            //                                     textSize: '2rem',
            //                                     strokeLinecap: 'flat',
            //                                     transition: 'stroke-dashoffset 0.5s ease 0s',
            //                                 })}/>
            //                              </FinishedGamesRating>
            //                          </FinishedGamesContentWrapper>
            //                      </FinishedGamesCard>
            //                 )
            //             })
            //         }
            //     </FinishedGamesWrapper>
            // </FinishedGamesContainer>
        )
    }
}

export default UpcomingGames